import React, { useState, useContext } from "react";
import { DialogContext } from "components/Shared/DialogProvider";
import { MSelect } from "components/Shared";
import Button from "@mui/material/Button";
import { EmployeeDetailDto } from "interfaces/Mueller.Business.Models";

interface CopyMappingsDialogContentProps { 
  onCopyMappingsClick: (id: number) => void,
  employeeCopyOptions: EmployeeDetailDto[],
}

const CopyMappingsDialogContent = (props: CopyMappingsDialogContentProps) => {
  const [employeeIdToCopy, setEmployeeIdToCopy] = useState<number>();
  const dialog = useContext(DialogContext);

  const onCopyCancelClick = () => {
    setEmployeeIdToCopy(null);
    dialog.hide();
  };

  const selectionOnChange = (value) => {
    if (value)
      setEmployeeIdToCopy(value);
    else
      setEmployeeIdToCopy(null);
  };

  return (
    <div className="copy-employee-mappings-dialog">
      <div className="copy-employee-mappings-dialog-selection-label">
        Copy mappings from
      </div>
      <MSelect
        options={props.employeeCopyOptions.map(e => { return { label: `${e.firstName} ${e.lastName}`, value: e.employeeId }; })}
        onChange={(newOption) => selectionOnChange(newOption.value)}
        placeholder="Select Employee"
      />
      <div className="copy-employee-mappings-dialog-buttons-container">
        <div className="copy-employee-mappings-dialog-copy-button">
          <Button
            onClick={() => props.onCopyMappingsClick(employeeIdToCopy)}
            disabled={!employeeIdToCopy}
          >
            Copy
          </Button>
        </div>
        <div className="copy-employee-mappings-dialog-cancel-button">
          <Button
            onClick={onCopyCancelClick} >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CopyMappingsDialogContent;
